import { RouteNames } from "@/types/router"
import { createRouter, createWebHistory } from "vue-router"

import TheCustomerNavigation from "@/components/navigation/TheCustomerNavigation.vue"

import Settings from "@/views/settings/SettingsView.vue"

import Customer from "@/views/customer/CustomerView.vue"
import CustomerAgreements from "@/views/customer/agreements/AgreementsView.vue"
import CustomerChangeOfTenancyCompleted from "@/views/customer/changeOfTenancy/components/CotCompleted.vue"
import CustomerChangeOfTenancy from "@/views/customer/changeOfTenancy/ChangeOfTenancyView.vue"
import CustomerComplaints from "@/views/customer/complaints/ComplaintsView.vue"
import CustomerFinancials from "@/views/customer/financials/FinancialsView.vue"
import CustomerFinancialsSetUpPaymentPlanView from "@/views/customer/financials/SetUpPaymentPlanView.vue"
import IssueBillCompleted from "@/views/customer/financials/IssueBillCompletedView.vue"
import IssueBillFailed from "@/views/customer/financials/IssueBillFailedView.vue"
import IssueBill from "@/views/customer/financials/IssueBillView.vue"
import RefundView from "@/views/customer/financials/flows/RefundView.vue"
import CustomerReviewPayment from "@/views/customer/financials/flows/ReviewPaymentAmount.vue"
import CustomerImbpBookingComplete from "@/views/customer/imbp/CustomerImbpBookingCompletedView.vue"
import CustomerImbpBooking from "@/views/customer/imbp/CustomerImbpBookingView.vue"
import CustomerImbp from "@/views/customer/imbp/CustomerImbpView.vue"
import CustomerJunifer from "@/views/customer/junifer/JuniferView.vue"
import CustomerMeterpoints from "@/views/customer/meterpoints/MeterpointsView.vue"
import CustomerOverview from "@/views/customer/overview/OverviewView.vue"
import CustomerDeceased from "@/views/customer/overview/deceased/DeceasedFlow.vue"
import CustomerRenewals from "@/views/customer/renewals/RenewalsView.vue"
import CustomerSearch from "@/views/customer/search/CustomerSearchView.vue"
import CustomerTimeline from "@/views/customer/timeline/TimelineView.vue"
import CustomerSmartDevices from "@/views/customer/smartDevices/SmartDevicesView.vue"

import Issues from "@/views/issues/IssuesView.vue"
import TariffQuoter from "@/views/tariffQuoter/TariffQuoter.vue"

import OpsDirectDebitReviewListView from "@/views/operations/directDebitReviews/OpsDirectDebitReviewListView.vue"
import OpsSmartChargingView from "@/views/operations/smartCharging/OpsSmartChargingView.vue"
import AdminEnergyProductsView from "@/views/admin/energyProducts/AdminEnergyProductsView.vue"
import AdminDcaAllocationView from "@/views/admin/dcaAllocation/AdminDcaAllocationView.vue"
import AdminFeaturesView from "@/views/admin/features/AdminFeaturesView.vue"
import AdminMaintenanceView from "@/views/maintenance/AdminMaintenanceView.vue"
import OpsReferralCodeView from "@/views/operations/referrals/OpsReferralCodeView.vue"
import OpsReferralsView from "@/views/operations/referrals/OpsReferralsView.vue"
import AdminUserListView from "@/views/admin/users/AdminUserListView.vue"
import OpsEnrolmentsView from "@/views/operations/enrolments/OpsEnrolmentsView.vue"
import AdminSyncAccountsView from "@/views/admin/syncAccounts/AdminSyncAccountsView.vue"

import AuthFailed from "@/views/AuthFailed.vue"
import NotFound from "@/views/NotFound.vue"

import { registerAuthMiddleware } from "@/middleware/auth"
import { registerCustomerMiddleware } from "@/middleware/customer"
import AdminUserEditView from "@/views/admin/users/AdminUserEditView.vue"
import IssueView from "@/views/customer/issues/IssueView.vue"
import MeterReadingsListView from "@/views/operations/meterReadings/MeterReadingsListView.vue"
import OpsSmsSenderView from "@/views/operations/smsSender/OpsSmsSenderView.vue"
import OpsSmartMeterView from "@/views/operations/smartMeters/OpsSmartMeterView.vue"
import OpsComplaintView from "@/views/operations/complaints/OpsComplaintView.vue"
import OpsTradingDataView from "@/views/operations/tradingData/OpsTradingDataView.vue"
import OpsCreditChecksListView from "@/views/operations/creditChecks/OpsCreditChecksListView.vue"
import AdminConfigurationsView from "@/views/admin/configurations/AdminConfigurationsView.vue"
import OpsFreshdeskContactsView from "@/views/operations/freshdeskTickets/OpsFreshdeskContactsView.vue"
import OpsFreshdeskTicketsView from "@/views/operations/freshdeskTickets/OpsFreshdeskTicketsView.vue"
import AdminTestAccountsView from "@/views/admin/testAccounts/AdminTestAccountsView.vue"
import AdminNewsfeedListView from "@/views/admin/newsfeed/AdminNewsfeedListView.vue"
import AdminNewsfeedCreateView from "@/views/admin/newsfeed/AdminNewsfeedCreateView.vue"
import AdminNewsfeedEditView from "@/views/admin/newsfeed/AdminNewsfeedEditView.vue"
import AdminEmailTemplatesListView from "@/views/admin/emailTemplates/AdminEmailTemplatesListView.vue"
import AdminEmailTemplatesCreateView from "@/views/admin/emailTemplates/AdminEmailTemplatesCreateView.vue"
import AdminEmailTemplatesDetailView from "@/views/admin/emailTemplates/AdminEmailTemplatesDetailView.vue"
import AdminEmailTemplatesSyncView from "@/views/admin/emailTemplates/AdminEmailTemplatesSyncView.vue"
import { SYNC_ROUTE_PATH } from "@/views/admin/emailTemplates/helpers/emailTemplateSync"
import AdminExternalEmailTemplateDetailView from "@/views/admin/emailTemplates/AdminExternalEmailTemplateDetailView.vue"
import OpsDrawListView from "@/views/operations/loyalty/OpsDrawListView.vue"
import OpsDrawDetailView from "@/views/operations/loyalty/OpsDrawDetailView.vue"
import AdminEmailVolumesView from "@/views/admin/emailVolumes/AdminEmailVolumesView.vue"
import AdminEmailThrottlesView from "@/views/admin/emailThrottles/AdminEmailThrottlesView.vue"
import AdminMarketingBannersView from "@/views/admin/marketingBanners/AdminMarketingBannersView.vue"
import AdminServicesListView from "@/views/admin/services/AdminServicesListView.vue"
import ServiceView from "@/views/admin/services/ServiceView.vue"
import TheServicesNavigation from "@/components/navigation/TheServicesNavigation.vue"
import AdminServiceConfigView from "@/views/admin/serviceConfig/AdminServiceConfigView.vue"
import AdminServiceConfigDetailView from "@/views/admin/serviceConfig/AdminServiceConfigDetailView.vue"
import AdminServiceJobsView from "@/views/admin/serviceJobs/AdminServiceJobsView.vue"
import AdminWarrantsView from "@/views/admin/warrants/AdminWarrantsView.vue"
import AdminWarrantsDcaView from "@/views/admin/warrants/AdminWarrantsDcaView.vue"
import AdminWarrantsFilesView from "@/views/admin/warrants/AdminWarrantsFilesView.vue"
import WarrantsCommunicationGroupsView from "@/views/admin/warrants/WarrantsCommunicationGroupsView.vue"
import WarrantsCommunicationsView from "@/views/admin/warrants/WarrantsCommunicationsView.vue"

import SmartPayAsYouGoView from "@/views/customer/financials/SmartPayAsYouGoView.vue"

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // TODO: add home page & customer search back when development has started
    // {
    //   path: '/',
    //   name: RouteNames.Home,
    //   components: {
    //     view: Home,
    //   },
    //   meta: {
    //     permissions: [],
    //   },
    // },
    {
      path: "/",
      name: RouteNames.CustomerSearch,
      components: {
        view: CustomerSearch,
      },
      meta: {
        permissions: ["agent.customer"],
      },
    },
    {
      path: "/settings",
      name: RouteNames.Settings,
      components: {
        view: Settings,
      },
    },
    // TODO: SEE ABOVE
    // {
    //   path: '/customer',
    //   name: RouteNames.CustomerSearch,
    //   components: {
    //     view: CustomerSearch,
    //   },
    //   meta: {
    //     permissions: ['agent.customer'],
    //   },
    // },

    {
      path: "/customer/:accountNumber",
      components: {
        view: Customer,
        navigationDrawer: TheCustomerNavigation,
      },
      meta: {
        permissions: ["agent.customer"],
      },
      children: [
        {
          path: "",
          name: RouteNames.CustomerOverview,
          component: CustomerOverview,
        },
        {
          path: "timeline",
          name: RouteNames.CustomerTimeline,
          component: CustomerTimeline,
        },
        {
          path: "financials",
          name: RouteNames.CustomerFinancials,
          component: CustomerFinancials,
        },
        {
          path: "financials/transactions",
          name: RouteNames.CustomerFinancialsTransactions,
          component: CustomerFinancials,
        },
        {
          path: "financials/refund-review",
          name: RouteNames.CustomerRefundReview,
          component: RefundView,
        },
        {
          path: "financials/payment-review",
          name: RouteNames.CustomerReviewPaymentAmount,
          component: CustomerReviewPayment,
        },
        {
          path: "financials/issue-bill",
          name: RouteNames.CustomerIssueBill,
          component: IssueBill,
        },
        {
          path: "financials/issued-bill",
          name: RouteNames.CustomerIssueBillCompleted,
          component: IssueBillCompleted,
        },
        {
          path: "financials/set-up-payment-plan",
          name: RouteNames.CustomerFinancialsSetUpPaymentPlan,
          component: CustomerFinancialsSetUpPaymentPlanView,
        },
        {
          path: "issue-bill-failed",
          name: RouteNames.CustomerIssueBillFailed,
          component: IssueBillFailed,
        },
        {
          path: "meterpoints",
          name: RouteNames.CustomerMeterpoints,
          component: CustomerMeterpoints,
        },
        {
          path: "smart-devices",
          name: RouteNames.CustomerSmartDevices,
          component: CustomerSmartDevices,
        },
        {
          path: "cot",
          name: RouteNames.CustomerChangeOfTenancy,
          component: CustomerChangeOfTenancy,
        },
        {
          path: "cot/completed",
          name: RouteNames.CustomerChangeOfTenancyCompleted,
          component: CustomerChangeOfTenancyCompleted,
        },
        {
          path: "agreements",
          name: RouteNames.CustomerAgreements,
          component: CustomerAgreements,
        },
        {
          path: "complaints",
          name: RouteNames.CustomerComplaints,
          component: CustomerComplaints,
        },
        {
          path: "junifer",
          name: RouteNames.CustomerJunifer,
          component: CustomerJunifer,
        },
        {
          path: "renewals",
          name: RouteNames.CustomerRenewals,
          component: CustomerRenewals,
        },
        {
          path: "imbp",
          name: RouteNames.CustomerImbp,
          component: CustomerImbp,
        },
        {
          path: "financials/smart-pay-as-you-go",
          name: RouteNames.CustomerSpayg,
          component: SmartPayAsYouGoView,
        },
        {
          path: "imbp/booking",
          name: RouteNames.CustomerImbpBooking,
          component: CustomerImbpBooking,
        },
        {
          path: "imbp/booking/information",
          name: "CustomerImbpBookingComplete",
          component: CustomerImbpBookingComplete,
        },
        {
          path: "deceased",
          name: RouteNames.CustomerDeceased,
          component: CustomerDeceased,
        },
      ],
    },
    {
      path: "/tariff-quoter",
      name: RouteNames.TariffQuoter,
      components: {
        view: TariffQuoter,
      },
    },
    {
      path: "/issues",
      name: RouteNames.Issues,
      components: {
        view: Issues,
      },
      // meta: {
      //   permissions: ['agent.customer'],
      // },
    },
    {
      path: "/issues/:issueId",
      name: RouteNames.CustomerOperationsIssues,
      components: {
        view: IssueView,
      },
      meta: {
        permissions: ["agent.customer"],
      },
    },
    {
      path: "/auth-failed",
      name: RouteNames.AuthFailed,
      components: { view: AuthFailed },
      meta: {
        skipAuth: true,
      },
    },
    {
      path: "/admin/users",
      name: RouteNames.AdminUserList,
      components: {
        view: AdminUserListView,
      },
      meta: {
        permissions: ["admin.users"],
      },
    },
    {
      path: "/admin/sync-accounts",
      name: RouteNames.AdminSyncUsers,
      components: {
        view: AdminSyncAccountsView,
      },
      meta: {
        permissions: ["admin.synchronisedAccounts"],
      },
    },
    {
      path: "/admin/user/:userId",
      name: RouteNames.AdminUserEdit,
      components: {
        view: AdminUserEditView,
      },
      meta: {
        permissions: ["admin.users"],
      },
    },
    {
      path: "/admin/energy-products",
      name: RouteNames.AdminEnergyProducts,
      components: {
        view: AdminEnergyProductsView,
      },
      meta: {
        permissions: ["admin.energyProducts"],
      },
    },
    {
      path: "/operations/dca-management",
      name: RouteNames.AdminDcaManagement,
      components: {
        view: AdminDcaAllocationView,
      },
      meta: {
        // granted by the debt_management role
        permissions: ["admin.debtCollection"],
      },
    },
    {
      path: "/admin/features-admin",
      name: RouteNames.AdminFeaturesAdmin,
      components: {
        view: AdminFeaturesView,
      },
      meta: {
        permissions: ["admin.featuresAdmin"],
      },
    },
    {
      path: "/admin/configurations-admin",
      name: RouteNames.AdminConfigurations,
      components: {
        view: AdminConfigurationsView,
      },
      meta: {
        permissions: ["admin.featuresAdmin"],
      },
    },

    {
      path: "/admin/maintenance",
      name: RouteNames.AdminMaintenance,
      components: {
        view: AdminMaintenanceView,
      },
      meta: {
        permissions: ["admin.featuresAdmin"],
      },
    },
    {
      path: "/operations/vouchers",
      name: RouteNames.AdminReferrals,
      components: {
        view: OpsReferralsView,
      },
      meta: {
        permissions: ["admin.referrals"],
      },
    },
    {
      path: "/operations/vouchers/:referralCode",
      name: RouteNames.AdminReferralCode,
      components: {
        view: OpsReferralCodeView,
      },
      meta: {
        permissions: ["admin.referrals"],
      },
    },
    {
      path: "/operations/direct-debit-reviews",
      name: RouteNames.AdminDirectDebitReviews,
      components: {
        view: OpsDirectDebitReviewListView,
      },
      meta: {
        permissions: ["admin.directDebitReviews"],
      },
    },
    {
      path: "/operations/smart-charging",
      name: RouteNames.AdminSmartCharging,
      components: {
        view: OpsSmartChargingView,
      },
      meta: {
        permissions: ["admin.smartCharging"],
      },
    },
    {
      path: "/operations/deposit-requests",
      name: RouteNames.AdminCreditChecks,
      components: {
        view: OpsCreditChecksListView,
      },
      meta: {
        permissions: ["admin.depositRequests"],
      },
    },
    {
      path: "/operations/meter-readings",
      name: RouteNames.MeterReadings,
      components: {
        view: MeterReadingsListView,
      },
      meta: {
        permissions: ["admin.billing"],
      },
    },
    {
      path: "/operations/sms-sender",
      name: RouteNames.AdminSmsSender,
      components: {
        view: OpsSmsSenderView,
      },
      meta: {
        permissions: ["admin.billing"],
      },
    },
    {
      path: "/operations/onboarding",
      name: RouteNames.AdminEnrolments,
      components: {
        view: OpsEnrolmentsView,
      },
      meta: {
        permissions: ["admin.users"],
      },
    },
    {
      path: "/operations/smart-meters",
      name: RouteNames.AdminSmartMeters,
      components: {
        view: OpsSmartMeterView,
      },
      meta: {
        permissions: ["agent.customer"],
      },
    },
    {
      path: "/operations/complaints",
      name: RouteNames.AdminComplaints,
      components: {
        view: OpsComplaintView,
      },
      meta: {
        permissions: ["agent.customer"],
      },
    },
    {
      path: "/operations/trades",
      name: RouteNames.AdminTradingData,
      components: {
        view: OpsTradingDataView,
      },
      meta: {
        permissions: ["admin.trades"],
      },
    },
    {
      path: "/operations/freshdesk-contacts",
      name: RouteNames.AdminFreshdeskContacts,
      components: {
        view: OpsFreshdeskContactsView,
      },
      meta: {
        permissions: ["admin.users"],
      },
    },
    {
      path: "/operations/freshdesk-contacts/:contactId",
      name: RouteNames.AdminFreshdeskTickets,
      components: {
        view: OpsFreshdeskTicketsView,
      },
      meta: {
        permissions: ["admin.users"],
      },
    },
    {
      path: "/admin/test-accounts",
      name: RouteNames.AdminTestAccounts,
      components: {
        view: AdminTestAccountsView,
      },
      meta: {
        permissions: ["admin.users"],
      },
    },
    {
      path: "/admin/newsfeed",
      name: RouteNames.AdminNewsfeed,
      components: {
        view: AdminNewsfeedListView,
      },
      meta: {
        permissions: ["admin.newsfeed"],
      },
    },
    {
      path: "/admin/newsfeed/create",
      name: RouteNames.AdminNewsfeedCreate,
      components: {
        view: AdminNewsfeedCreateView,
      },
      meta: {
        permissions: ["admin.newsfeed"],
      },
    },
    {
      path: "/admin/newsfeed/:articleId",
      name: RouteNames.AdminNewsfeedEdit,
      components: {
        view: AdminNewsfeedEditView,
      },
      meta: {
        permissions: ["admin.newsfeed"],
      },
    },
    {
      path: "/admin/email-templates",
      name: RouteNames.AdminEmailTemplates,
      components: {
        view: AdminEmailTemplatesListView,
      },
      meta: {
        permissions: ["admin.emailTemplates"],
      },
    },
    {
      path: "/admin/email-headline-image",
      name: RouteNames.AdminEmailHeadlineImage,
      components: {
        view: () =>
          import("@/views/admin/emailHeadlineImage/AdminEmailHeadlineImageView.vue"),
      },
      meta: {
        permissions: ["admin.emailTemplates"],
      },
    },
    {
      path: "/admin/email-templates/create",
      name: RouteNames.AdminEmailTemplatesCreate,
      components: {
        view: AdminEmailTemplatesCreateView,
      },
      meta: {
        permissions: ["admin.emailTemplates"],
      },
    },
    {
      path: SYNC_ROUTE_PATH,
      name: RouteNames.AdminEmailTemplatesSync,
      components: {
        view: AdminEmailTemplatesSyncView,
      },
      meta: {
        permissions: ["admin.emailTemplates"],
        keepHash: true,
      },
    },
    {
      path: "/admin/email-templates/external/:id",
      name: RouteNames.AdminExternalEmailTemplateDetail,
      components: {
        view: AdminExternalEmailTemplateDetailView,
      },
      meta: {
        permissions: ["admin.emailTemplates"],
      },
    },
    {
      path: "/admin/email-templates/:communicationId",
      name: RouteNames.AdminEmailTemplatesDetail,
      components: {
        view: AdminEmailTemplatesDetailView,
      },
      meta: {
        permissions: ["admin.emailTemplates"],
      },
    },
    {
      path: "/operations/loyalty/draws",
      name: RouteNames.AdminDrawList,
      components: {
        view: OpsDrawListView,
      },
      meta: {
        permissions: ["admin.loyalty"],
      },
    },
    {
      path: "/operations/loyalty/draws/:drawId",
      name: RouteNames.AdminDrawDetail,
      components: {
        view: OpsDrawDetailView,
      },
      meta: {
        permissions: ["admin.loyalty"],
      },
    },
    {
      path: "/admin/email-volumes",
      name: RouteNames.AdminEmailVolumes,
      components: {
        view: AdminEmailVolumesView,
      },
      meta: {
        permissions: ["admin.emailVolumes"],
      },
    },
    {
      path: "/admin/email-throttles",
      name: RouteNames.AdminEmailThrottles,
      components: {
        view: AdminEmailThrottlesView,
      },
      meta: {
        permissions: ["admin.emailThrottles"],
      },
    },
    {
      path: "/admin/marketing-banners",
      name: RouteNames.AdminMarketingBanners,
      components: {
        view: AdminMarketingBannersView,
      },
      meta: {
        permissions: ["admin.marketingBanners"],
      },
    },
    {
      path: "/admin/services",
      name: RouteNames.AdminServices,
      components: {
        view: AdminServicesListView,
      },
      meta: {
        permissions: ["admin.serviceConfig"],
      },
    },
    {
      path: "/admin/services/:serviceName",
      components: {
        view: ServiceView,
        navigationDrawer: TheServicesNavigation,
      },
      meta: {
        permissions: ["admin.serviceConfig"],
      },
      children: [
        {
          path: "jobs",
          name: RouteNames.AdminServiceJobs,
          component: AdminServiceJobsView,
        },
        {
          path: "configurations",
          name: RouteNames.AdminServiceConfig,
          component: AdminServiceConfigView,
        },
        {
          path: "configurations/:configName",
          name: RouteNames.AdminServiceConfigDetail,
          component: AdminServiceConfigDetailView,
        },
        {
          path: "warrants",
          name: RouteNames.AdminServiceWarrants,
          component: AdminWarrantsView,
        },
        {
          path: "warrants/dca",
          name: RouteNames.AdminServiceWarrantsDca,
          component: AdminWarrantsDcaView,
        },
        {
          path: "warrants/files",
          name: RouteNames.AdminServiceWarrantsFiles,
          component: AdminWarrantsFilesView,
        },
        {
          path: "warrants/:accountNumber/summary",
          name: RouteNames.AdminServiceWarrantsCommunications,
          component: WarrantsCommunicationGroupsView,
        },
        {
          path: "warrants/:accountNumber/communications/:groupId",
          name: RouteNames.AdminServiceWarrantsCommunicationGroup,
          component: WarrantsCommunicationsView,
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      components: {
        view: NotFound,
      },
    },
  ],
})

registerAuthMiddleware(router)
registerCustomerMiddleware(router)

export default router
